// extracted by mini-css-extract-plugin
export default {"country":"Country_country__Xyywh","flag":"Country_flag__A6w-5","innerContent":"Country_innerContent__20uan","countryColor":"Country_countryColor__Xumm0"};